import React from 'react';
import {Box} from '~/common/fabric/Card/components/Box/Box';
import {Colors} from '~/common/fabric/Card/components/Colors/Colors';
import {Group} from '~/common/fabric/Card/components/Group/Group';
import {Header} from '~/common/fabric/Card/components/Header/Header';
import {EditBox} from '~/common/fabric/CreateDesign/components/EditBox/EditBox';
import './BackgroundEditor.sass';
import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {desktopColors} from '~/common/fabric/CreateDesign/constants';
import {useBackground} from '~/common/fabric/CreateDesign/components/Background/actions/useBackground';
import {SparkleIcon} from '~library/svg/SparkleIcon';
import {Typography} from '~library/atoms/Typography';

export const BackgroundEditor = () => {
  const {backgroundIcons, onColorChange, onTextureChange, selectedBackground} = useBackground();

  return (
    <div className="background-editor">
      <EditBox className="background-editor__content">
        <Group>
          <Header
            title="Textures"
            extra={
              <div className="background-editor__header--animated">
                <SparkleIcon ratio={0.75} className="background-editor__svg" />
                <Typography as="h1" variant="label2" color="tanzanite">
                  Animated
                </Typography>
              </div>
            }
          />
          <Box className="background-editor__box">
            <Icons
              icons={backgroundIcons}
              selectedIcon={selectedBackground?.icon}
              onClick={onTextureChange}
              square
              height={40}
              width={46}
              className="background-editor__box__icons"
            />
          </Box>
        </Group>
        <Group>
          <Header title="Solid Colors" />
          <Box className="background-editor__box">
            <Colors
              colors={desktopColors}
              onClick={onColorChange}
              height={40}
              width={40}
              className="background-editor__box__icons__solid_colors"
            />
          </Box>
        </Group>
      </EditBox>
    </div>
  );
};
